import { parseISO, isValid, format } from 'date-fns'

// Shortened date for the Payment Report tables only: "15 Jul 26" instead of the
// app-wide "15 Jul 2026" (utils/dates DISPLAY_FORMAT). Deliberately NOT changing
// DISPLAY_FORMAT — that would shorten dates on every page. Export mappers keep the
// full-year displayDate() for cleaner spreadsheet parsing.
const SHORT_FORMAT = 'dd MMM yy'

export function shortDate(date: string | Date | null | undefined): string {
  if (!date) return '—'
  const d = typeof date === 'string' ? parseISO(date) : date
  return isValid(d) ? format(d, SHORT_FORMAT) : '—'
}
